import moment from 'moment'
moment.locale('de')
export default function (value, format = 'DD.MM.YYYY') {
  if (!value) {
    return value
  }
  return moment(value).fromNow()
}
